import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'react-final-form';

import WithLabel, { LABEL_STYLES } from '../../../../../components/with-label/WithLabel';
import CommonDropdown from '../../../../../components/common-dropdown/CommonDropdown';
import { REQUEST_TYPE } from '../../../../constants/contact';
import WithError from '../../../../../components/with-error/WithError';

import scss from '../Steps.module.scss';

function StepRequestType() {
  const { t } = useTranslation('contact');

  const requestTypeOptions = [
    { label: t('bugReport'), value: REQUEST_TYPE.BUG_REPORT },
    { label: t('requestSupport'), value: REQUEST_TYPE.SUPPORT },
  ];

  return (
    <div className={scss.stepFormWrapper}>
      <Field name='requestType'>
        {({ input, meta }) => (
          <WithLabel label={t('requestType')} variant={LABEL_STYLES.COLUMN} isBold isTwoDots isRequired>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonDropdown
                name={input.name}
                options={requestTypeOptions}
                value={input.value}
                onSelect={input.onChange}
                onBlur={input.onBlur}
                onFocus={input.onFocus}
                isError={meta.touched && meta.error}
                placeholder={t('selectTypeOfRequest')}
                isBorder
              />
            </WithError>
          </WithLabel>
        )}
      </Field>
    </div>
  );
}

export default StepRequestType;
